import http from "./http-common";
import VideoModel from "../models/video";
import qs from "qs";

// eslint-disable-next-line
export default new (class VideoService {
  // Get all
  async getVideo({ page = 1, pageSize = 5, sort = "desc" }) {
    const query = qs.stringify(
      {
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/videos?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((video) => VideoModel.get(video))
        );

        const meta = response.data.meta;

        return [data, meta];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getVideoBySlug(slug) {
    return await http
      // ให้ Strapi กรองด้วย slug — ดึงมาทั้งหมดแล้วค่อยหาจะได้แค่ 25 รายการแรก
      .get(`/videos?pLevel&filters[Slug][$eq]=${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((video) => VideoModel.get(video))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getAnotherVideo(slug) {
    return await http
      .get(
        `videos?sort[0]=publishedAt:desc&pLevel&pagination[page]=1&pagination[pageSize]=3&filters[Slug][$ne]=${slug}`
      )
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((video) => VideoModel.get(video))
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getVideoByTag({ sort = "desc", tag = "" }) {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              tag: {
                tag: {
                  $eq: tag,
                },
              },
            },
          ],
        },
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/videos?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((video) => VideoModel.get(video))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
